module.exports = __webpack_public_path__ + "img/saleCoin.6d24a7ae.0f5cd5de.svg";